import { render, staticRenderFns } from "./GridSwiperExp.vue?vue&type=template&id=46188996&scoped=true"
import script from "./GridSwiperExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridSwiperExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridSwiperExp.vue?vue&type=style&index=0&id=46188996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46188996",
  null
  
)

export default component.exports